import { WidgetType } from '@baserow/modules/dashboard/widgetTypes'
import ChartWidget from './components/widget/ChartWidget'
import PieChartWidget from './components/widget/PieChartWidget'
import ChartWidgetSettings from './components/widget/ChartWidgetSettings'
import ChartBarWidgetSvg from '@baserow/modules/vokalisDashboard/assets/images/widgets/chart_bar_widget.svg?url'
import ChartLineWidgetSvg from '@baserow/modules/vokalisDashboard/assets/images/widgets/chart_line_widget.svg?url'
import PieChartWidgetSvg from '@baserow/modules/vokalisDashboard/assets/images/widgets/pie_chart_widget.svg?url'
import DoughnutChartWidgetSvg from '@baserow/modules/vokalisDashboard/assets/images/widgets/doughnut_chart_widget.svg?url'

export class ChartWidgetType extends WidgetType {
  static getType() {
    return 'chart'
  }

  get name() {
    return this.$t('chartWidget.name')
  }

  get component() {
    return ChartWidget
  }

  get settingsComponent() {
    return ChartWidgetSettings
  }

  get variations() {
    return [
      {
        name: this.$t('chartWidget.bar'),
        createWidgetImage: ChartBarWidgetSvg,
        type: this,
        params: {
          default_series_chart_type: 'BAR',
        },
        dropdownIcon: '',
      },
      {
        name: this.$t('chartWidget.line'),
        createWidgetImage: ChartLineWidgetSvg,
        type: this,
        params: {
          default_series_chart_type: 'LINE',
        },
        dropdownIcon: '',
      },
    ]
  }

  async dataSourceUpdated(widget, data) {
    const widgetSeries = widget.series_config || []
    const dataSourceSeriesIds = (data?.aggregation_series || []).map(
      (series) => series.id
    )
    const widgetConfSeriesIds = widgetSeries.map((conf) => conf.series_id)

    const missingConfIds = dataSourceSeriesIds.filter(
      (id) => !widgetConfSeriesIds.includes(id)
    )

    if (missingConfIds.length > 0) {
      const values = JSON.parse(JSON.stringify(widget))
      const originalValues = JSON.parse(JSON.stringify(widget))
      for (const missingId of missingConfIds) {
        values.series_config.push({
          series_id: missingId,
          series_chart_type: widget.default_series_chart_type,
        })
      }

      await this.app.$store.dispatch(
        'dashboardApplication/updateWidget',
        {
          widgetId: widget.id,
          values,
          originalValues,
        }
      )
    }
  }

  isLoading(widget, data) {
    const dataSourceId = widget.data_source_id
    if (data[dataSourceId] && Object.keys(data[dataSourceId]).length !== 0) {
      return false
    }
    return true
  }
}

export class PieChartWidgetType extends WidgetType {
  static getType() {
    return 'pie_chart'
  }

  get name() {
    return this.$t('pieChartWidget.name')
  }

  get component() {
    return PieChartWidget
  }

  get settingsComponent() {
    return ChartWidgetSettings
  }

  get variations() {
    return [
      {
        name: this.$t('pieChartWidget.pie'),
        createWidgetImage: PieChartWidgetSvg,
        type: this,
        params: {
          default_series_chart_type: 'PIE',
        },
        dropdownIcon: '',
      },
      {
        name: this.$t('pieChartWidget.doughnut'),
        createWidgetImage: DoughnutChartWidgetSvg,
        type: this,
        params: {
          default_series_chart_type: 'DOUGHNUT',
        },
        dropdownIcon: '',
      },
    ]
  }

  async dataSourceUpdated(widget, data) {
    const widgetSeries = widget.series_config || []
    const dataSourceSeriesIds = (data?.aggregation_series || []).map(
      (series) => series.id
    )
    const widgetConfSeriesIds = widgetSeries.map((conf) => conf.series_id)

    const missingConfIds = dataSourceSeriesIds.filter(
      (id) => !widgetConfSeriesIds.includes(id)
    )

    if (missingConfIds.length > 0) {
      const values = JSON.parse(JSON.stringify(widget))
      const originalValues = JSON.parse(JSON.stringify(widget))
      for (const missingId of missingConfIds) {
        values.series_config.push({
          series_id: missingId,
          series_chart_type: widget.default_series_chart_type,
        })
      }

      await this.app.$store.dispatch(
        'dashboardApplication/updateWidget',
        {
          widgetId: widget.id,
          values,
          originalValues,
        }
      )
    }
  }

  isLoading(widget, data) {
    const dataSourceId = widget.data_source_id
    if (data[dataSourceId] && Object.keys(data[dataSourceId]).length !== 0) {
      return false
    }
    return true
  }
}

